export const CUSTOM_PRESENTER_FILE_INPUT_ID = 'upload-avatar-file-input';
